<template>

  <div class="card">
    <div class="row">
      <div class="col-md-10">
        <h5>Parámetros</h5>
      </div>
      <div class="col-md-2">
        <button class="btn btn-primary btn-raised" type="button" @click="save">Guardar</button>
      </div>
    </div>
    <div class="row" v-if="loading">
      <div class="col-md-12 text-center">
        Guardando.....
      </div>
    </div>
    <hr>
    <div class="row text-center" v-if="saved">
      <div class="col-md-1"></div>
      <div class="col-md-10">
        <div class="alert alert-success" role="alert">
          <button type="button" class="close" aria-label="Close" @click="saved= false"><span aria-hidden="true">&times;</span></button>
          <strong>Guardado</strong>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3 text-left">
      </div>
      <div class="col-md-3 text-left">
        <label>Comisión por fondeo</label>
        <input type="number" class="form-control" v-model="fund_comission_percentage">
      </div>
      <div class="col-md-3 text-left">
        <label>Porcentaje de primer pago</label>
        <input type="number" class="form-control" v-model="first_payment_percentage">
      </div>
    </div>
    <br>
  </div>


</template>

<script lang="js">
  export default  {
    name: 'supplier-parameters',
    props: ['id_supplier', 'usuario'],
    mounted() {
      axios.get( '/api/supplier/parameters/' + this.id_supplier).then(response => {
        this.fund_comission_percentage = response.data.fund_comission_percentage * 100
        this.first_payment_percentage = response.data.first_payment_percentage * 100
      })
    },
    data() {
      return {
        parameters:{},
        loading: false,
        fund_comission_percentage: 0,
        first_payment_percentage: 0,
        saved:false

      }
    },
    methods: {
      save(){
        this.loading = true
        this.saved = false
        var data = {
          fund_comission_percentage: this.fund_comission_percentage / 100,
          first_payment_percentage: this.first_payment_percentage/100
        }

        axios.post( '/api/supplier/parameters/' + this.id_supplier, data).then(response => {
          this.loading = false
          this.saved = true
        })
      }
    },
    computed: {

    }
}
</script>

<style scoped lang="scss">
  .supplier-parameters {

  }
  .row{
    margin-top: 15px;
  }
  .card{
    padding: 0 10px;
  }
</style>
